/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../ISymbolData';
import ActivePaylineFilter from './Filters/ActivePaylineFilter';
import ContinuousPaylineStreakFilter from './Filters/ContinuousPaylineStreakFilter';
import ContinuousReelStreakFilter from './Filters/ContinuousReelStreakFilter';
import StreakTrackerRuleBase from './StreakTrackerRuleBase';

const {ccclass, property} = cc._decorator;

/** Rule for determinining symbols on payline streaks. */
@ccclass
export default class PaylineSymbolCountRule extends StreakTrackerRuleBase
{
    /** [[Reel]] indexes to excludes. */
    @property({ type: [cc.Integer], visible: true })
    protected invalidReelIndexList: number[] = [];

    @property({ visible: true })
    protected samePayline: boolean = false;

    /** @hidden */
    private _activePaylineFilter: ActivePaylineFilter = null;
    private get activePaylineFilter(): ActivePaylineFilter
    {
        if (!this._activePaylineFilter)
        {
            this._activePaylineFilter = this.addComponent(ActivePaylineFilter);
        }

        return this._activePaylineFilter;
    }

    /** @hidden */
    private _continuousPaylineFilter: ContinuousPaylineStreakFilter = null;
    private get continuousPaylineFilter(): ContinuousPaylineStreakFilter
    {
        if (!this._continuousPaylineFilter)
        {
            this._continuousPaylineFilter = this.addComponent(ContinuousPaylineStreakFilter);
        }

        return this._continuousPaylineFilter;
    }

    /** @hidden */
    private _continuousReelFilter: ContinuousReelStreakFilter = null;
    private get continuousReelFilter(): ContinuousReelStreakFilter
    {
        if (!this._continuousReelFilter)
        {
            this._continuousReelFilter = this.addComponent(ContinuousReelStreakFilter);
        }

        return this._continuousReelFilter;
    }

    /** Rule to filter out symbols not on payline or continous. */
    protected applyRuleFilter(): ISymbolData[]
    {
        let validSymbols: ISymbolData[] = this.filterInvalidReels(this.validSymbols);

        // Active Payline Filtering
        validSymbols = this.activePaylineFilter.Filter(validSymbols);

        // Continuous Streak Filtering
        this.continuousPaylineFilter.MinStreak = this.minSymbolCount;
        this.continuousReelFilter.MinStreak = this.minSymbolCount;
        validSymbols = this.samePayline
            ? this.continuousPaylineFilter.Filter(validSymbols)
            : this.continuousReelFilter.Filter(validSymbols);

        return validSymbols;
    }

    /**
     * Filters out symbols that are contained in invalidReelIndexList.
     * @param symbols Symbols to filter.
     * @returns valid symbols.
     */
    private filterInvalidReels(symbols: ISymbolData[]): ISymbolData[]
    {
        if (this.invalidReelIndexList.length === 0) { return symbols; }

        if (this.reelConfigs.length > 0)
        {
            this.reelConfigs = this.reelConfigs.filter(x => this.invalidReelIndexList.indexOf(x.ReelIndex) < 0);
            // Return all symbols, and let reelConfigs
            // filtering take care of the rest.
            return symbols;
        }

        return symbols.filter(x => this.invalidReelIndexList.indexOf(x.ReelIndex) < 0);
    }
}
